import { render, staticRenderFns } from "./list-loader.vue?vue&type=template&id=fa5f6318&scoped=true&"
import script from "./list-loader.vue?vue&type=script&lang=js&"
export * from "./list-loader.vue?vue&type=script&lang=js&"
import style0 from "./list-loader.vue?vue&type=style&index=0&id=fa5f6318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5f6318",
  null
  
)

export default component.exports